<template>
       <div ref="componentBox" @mousemove="onmousermoves">
            <div>
                <div
                    v-for="(component,componentIndex) in currentCustomPage.components"
                    :key="componentIndex"
                    :class="insertIndex === componentIndex?'move-active':''||(insertIndex === -1&&componentIndex===0)?'move-active-top':''"
                    class="component-item"
                    @mousedown="onmousedowns($event,componentIndex)"
                >
                   <div class="name" @click="handleEditComponent(componentIndex)">{{ component.type_data.data.name }}</div>
                     <div class="component-item_delete" @click="handleDeleteComponent(componentIndex)">删除</div>
                    </div>
                </div>
              <!-- 鼠标按下临时dom -->
              <div v-show="mousedownInfo.status" @mouseup="onmouseups" ref="moveItem" class="mousedownInfo-item">
                <div class="name" >{{ mousedownInfo.name }}</div>
            </div>

        </div>
</template>
<style scoped>
  .move-active{
  border-bottom:2px #409EFF solid!important;
  box-shadow:0 1px 2px #409EFF!important;;
}
.move-active-top{
  border-top:2px #409EFF solid!important;
  box-shadow:1px 0 2px #409EFF!important;;
}
</style>
<script>
  export default{
    name: 'Factory',
    data(){
       return {
          // 拖拽
      offset_top: null,
      offset_left: null,
      offset_width: null,
      offset_height: null,
      // 临时保存信息，随鼠标移动
      mousedownInfo: {
        name: '',
        index: null,
        status:false,
        width:0,
        height:0
      },
      // 要插入的index
      insertIndex:null,
       }
    },
   methods:{
      // 获取移动父盒子的坐标，大小
    handMove() {
      const componentBox = this.$refs.componentBox
      let top = componentBox.offsetTop
      let left = componentBox.offsetLeft
      let parent = componentBox.offsetParent
      // 获取盒子左上角坐标
      //每一层父元素相加一次距离
      while (parent !== null){
        left += parent.offsetLeft;
        top += parent.offsetTop;
        parent = parent.offsetParent;
        }
      this.offset_top = top
      this.offset_left = left
      this.offset_width = componentBox.offsetWidth
      this.offset_height = componentBox.offsetHeight
      // 初始化移动item的宽度
      this.$refs.moveItem.style.width = componentBox.offsetWidth + 'px'
    },
    // 鼠标按下临时保存
    onmousedowns(event, index) {
      // 获取移动父盒子的坐标，大小
      this.handMove()

      const e= event || window.event
      this.mousedownInfo.name = this.currentCustomPage.components[index].type_data.data.name
      // 保存要删除的index
      this.mousedownInfo.index = index
      // 鼠标距离点击元素的宽高
      this.mousedownInfo.width = (e.clientX+document.documentElement.scrollLeft) - this.offset_left
      // （鼠标高度+超出浏览器高度） - 父盒子高度 / 每个item的高度88，取模% =  鼠标所在item的高度
      this.mousedownInfo.height = ((e.clientY+document.documentElement.scrollTop) - this.offset_top) % 88
      // 按下先初始化位置
    /*   this.$refs.moveItem.style.top = (e.clientY - this.mousedownInfo.height) + 'px'
      this.$refs.moveItem.style.left = (e.clientX - this.mousedownInfo.width) + 'px' */
    },
    // 鼠标移动时
    onmousermoves(event) {
      if(this.mousedownInfo.name){
          const e = event || window.event
        // 判断鼠标是否移出了盒子
        if( (e.clientX-this.offset_left)<0 ||(e.clientX-this.offset_left)>this.offset_width
          || ((e.clientY+document.documentElement.scrollTop)- this.offset_top)<-88
          || ((e.clientY+document.documentElement.scrollTop)- this.offset_top)>Number(this.offset_height)+88
          )
         {
          this.resetMove()
          return false
        }
          // 按下移动时展示，不拖拽可以进入编辑
          this.$set(this.mousedownInfo,'status',true)

          const stateIndex = ((e.clientY+document.documentElement.scrollTop)- this.offset_top) / 88
          this.insertIndex = (stateIndex.toFixed(0))-1
          // 根据鼠标位置计算移动item的位置
          this.$refs.moveItem.style.top = (e.clientY - this.mousedownInfo.height) + 'px'
          this.$refs.moveItem.style.left = (e.clientX - this.mousedownInfo.width) + 'px'
        
      }
    },
    // 鼠标释放时，
    // 进行元素的位置更改
    onmouseups() {
      const item = this.currentCustomPage.components.splice(this.mousedownInfo.index,1)
      this.currentCustomPage.components.splice(this.insertIndex+1,0,item[0])
      this.resetMove()
    },
    // 重置拖拽数据
    resetMove(){
      this.mousedownInfo={
        name:null,
        index:null,
        width:0,
        height:0,
      }
      this.insertIndex = null
      this.mousedownInfo.status = false;
    },

   }
  }
</script>



// WEBPACK FOOTER //
// src/views/basic/Factory.vue